// import React from "react";
// import { Navigate } from "react-router-dom";
// import { useAuth } from "../context/AuthContext";

// const ProtectedRoute = ({ children }) => {
//   const { isLoggedIn } = useAuth();

//   if (!isLoggedIn) {
//     return <Navigate to="/login" />;
//   }

//   return children;
// };

// export default ProtectedRoute;



// import React from "react";
// import { Redirect } from "react-router-dom";
// import { useSelector } from "react-redux";

// const ProtectedRoute = ({ children }) => {
//   const isLoggedIn = useSelector((state) => state.isLoggedIn);

//   if (!isLoggedIn) {
//     return <Redirect to="/login" />;
//   }

//   return children;
// };


// src/ProtectedRoute.js
import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { useSelector } from 'react-redux'; // Assuming you use Redux for state

const ProtectedRoute = ({ component: Component, layout: Layout, ...rest }) => {
  const isLoggedIn = useSelector((state) => state.isLoggedIn); // Replace with your actual state selector

  return (
    <Route
      {...rest}
      render={(props) =>
        isLoggedIn ? (
          <Layout>
            <Component {...props} />
          </Layout>
        ) : (
          <Redirect to="/login" />
        )
      }
    />
  );
};

export default ProtectedRoute;
